// extracted by mini-css-extract-plugin
module.exports = {"action":"action-1x7mD"};